import React, { useEffect } from "react";
import Input from "../modules/Input";
import DocUpload from "../modules/DocUpload";
import StaticField from "../StaticField";
import { useSelector, useDispatch } from "react-redux";
import { modifySpoc, modifySpocTotal } from "./redux/actions";

function SPOCDetails(props) {
  const dispatch = useDispatch();
  const spoc = useSelector((state) => state.spoc.pageInfo);
  const eduInfo = useSelector((state) => state.education);
  const tokenData = useSelector((state) => state.tokens.tokens);

  console.log("spoc", spoc);
  const addData = (type, data) => {
    dispatch(modifySpoc([type, data]));
  };
  const getSpoc = () => {
    let count = 0;
    let total = 0;
    let countList = [];
    let totalList = [];
    for (let i in spoc) {
      if (
        i === "firstName" ||
        i === "lastName" ||
        i === "email" ||
        i === "mobile" ||
        i === "campus"
      ) {
        // if (i === "campus") {
        //   if (props.others) {
        //     if (spoc[i]) {
        //       count += 1;
        //       countList = [...countList, i];
        //     }
        //   } else {
        //     count += 1;
        //     countList = [...countList, i];
        //   }
        // } else
        if (i !== "campus" && spoc[i]) {
          count += 1;
          countList = [...countList, i];
        } else if (i === "campus") {
          if (props.others) {
            if (spoc[i]) {
              count += 1;
              countList = [...countList, i];
            }
          } else {
            count += 1;
            countList = [...countList, i];
          }
        }
        total += 1;
        totalList = [...totalList, i];
        // else {
        // total += 1;
        // totalList = [...totalList, i];

        // }
      }
    }
    let finalpercentage = Math.floor(Math.abs(count / total) * 100);

    // setAllTotal({ ...allTotal, personal: finalpercentage });
    dispatch(modifySpocTotal(["spocTotal", finalpercentage]));
  };
  useEffect(() => {
    getSpoc();
  }, [spoc]);
  return (
    <div className="bank">
      <div className="field-set set-one set-top">
        <div className="set-left set">
          <div className="set-title">College SPOC Details</div>
          <Input
            placeholder={"First Name"}
            value={spoc.firstName}
            onChange={(e) => addData("firstName", e.replace(/[^a-zA-Z]/g, ""))}
          />
          <Input
            placeholder={"Last Name"}
            value={spoc.lastName}
            onChange={(e) => addData("lastName", e.replace(/[^a-zA-Z]/g, ""))}
          />
          <Input
            placeholder={"Email Address"}
            value={spoc.email}
            type={"password"}
            id={"password"}
            onChange={(e) => addData("email", e)}
          />{" "}
          <Input
            placeholder={"Mobile Number"}
            value={spoc.mobile}
            type={"password"}
            id={"password"}
            onChange={(e) =>
              addData("mobile", e.replace(/\D/g, "").slice(0, 10))
            }
          />{" "}
        </div>{" "}
        {/* </div> */}
        <div className="set-left set">
          <StaticField
            showTick={false}
            title={"College"}
            value={tokenData.registrationData.college}
          />
          <StaticField
            showTick={false}
            title={"City"}
            value={eduInfo.eduInfo.city}
          />
          <StaticField
            showTick={false}
            title={"Campus"}
            value={eduInfo?.eduInfo?.campusSpecific}
          />
          {props.others && (
            <Input
              placeholder={"Enter the name of your college campus"}
              value={spoc.campus}
              onChange={(e) => addData("campus", e)}
            />
          )}
        </div>
        {/* </div> */}
      </div>
    </div>
  );
}

export default SPOCDetails;
